import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { addQuestion } from "../../Services/QuizService";

const AddQuestion = ({ data, onClose, onCloseWithApi }) => {
    const [reqData, setReqData] = useState({
        id: "",
        type: "mcq",
        question: "",
        answer_id: "",
        options: [{ id: 1, option: "" }, { id: 2, option: "" }, { id: 3, option: "" }, { id: 4, option: "" }],
    });
    const [loader, setLoader] = useState(false);

    const handleChange = (field, value) => {
        setReqData({ ...reqData, [field]: value })
    };

    const handleChangeDynamic = (e, inputId) => {
        const updatedInputs = reqData?.options.map((input, index) =>
            inputId === index ? { ...input, option: e.target.value } : input
        );
        setReqData({ ...reqData, options: updatedInputs });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoader(true);
        let { ok } = await addQuestion(reqData);
        if (ok) {
            toast.success("Success");
            onCloseWithApi();
        }
        setLoader(false);
    };

    useEffect(() => {
        if (data?.data) {
            let { id, type, question, answer_id, options } = data?.data;
            let arr = []
            if (type == "mcq") {
                for (let i = 0; i < options?.length; i++) {
                    arr.push({ id: i, option: options[i]?.option });
                    if (options[i]?.id == answer_id) {
                        answer_id = i;
                    }
                };
                options = arr;
            };

            if (type == "boolean") {
                for (let i = 0; i < 4; i++) {
                    arr.push({ id: i, option: "" });
                };
                options = arr;
            };

            setReqData({ id, type, question, answer_id, options })
        };
    }, []);

    return (
        <div
            className="modal custom-modal fade bank-details show"
            id="add_items"
            role="dialog"
            aria-modal="true"
            style={{
                display: "block",
                background: "rgb(0 0 0 / 50%)",
            }}
        >
            <form onSubmit={(e) => handleSubmit(e)}>
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header text-start mb-0">
                                <h4 className="mb-0">{!reqData?.id ? "Add Question" : "Edit Question"}</h4>
                            </div>
                            <button
                                type="button"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => onClose()}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="bank-inner-details">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12">
                                        <div className="form-group">
                                            <label>Question</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Question"
                                                required
                                                value={reqData?.question}
                                                onChange={(e) => handleChange("question", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Type</label>
                                            <select required value={reqData?.type} onChange={(e) => handleChange("type", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option value="mcq" selected>MCQ</option>
                                                <option value="boolean">Boolean</option>
                                            </select>
                                        </div>
                                        {
                                            reqData?.type == "boolean" ?
                                                <div className="form-group">
                                                    <label>Answer</label>
                                                    <select required value={reqData?.answer_id} onChange={(e) => handleChange("answer_id", e.target.value)} class="form-select" aria-label="Default select example">
                                                        <option value="">Select Answer</option>
                                                        <option value={1}>True</option>
                                                        <option value={0}>False</option>
                                                    </select>
                                                </div>
                                                :
                                                <>
                                                    {reqData?.options?.map((input, index) => (
                                                        <div className="form-group">
                                                            <label>{`Option ${index + 1}`}</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Option"
                                                                required
                                                                value={input?.option}
                                                                onChange={(e) => handleChangeDynamic(e, index)}
                                                            />
                                                        </div>
                                                    ))}
                                                    <div className="form-group">
                                                        <label>Answer</label>
                                                        <select required value={reqData?.answer_id} onChange={(e) => handleChange("answer_id", e.target.value)} class="form-select" aria-label="Default select example">
                                                            <option value="">Select Answer</option>
                                                            {reqData?.options?.map((input, index) =>
                                                                <>
                                                                    {input?.option && <option value={input?.id}>{input?.option}</option>}
                                                                </>
                                                            )}
                                                        </select>
                                                    </div>
                                                </>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="bank-details-btn">
                                <button
                                    data-bs-dismiss="modal"
                                    className="btn bank-cancel-btn me-2"
                                    onClick={() => onClose()}
                                    disabled={loader}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn bank-save-btn"
                                    disabled={loader}
                                >
                                    {loader ? "Loading..." : "Save"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form >
        </div >
    );
};

export default AddQuestion;